import styles from "./starter_suggestions.module.scss"

interface Props {
  suggestions: string[]
  onSelect: (suggestion: string) => void
}

const StarterSuggestions = ({ suggestions, onSelect }: Props) => {
  if (suggestions.length === 0) return null

  return (
    <div className={styles["starter-suggestions"]} data-testid="starter-suggestions">
      <p className={styles["starter-suggestions-label"]}>Or start with one of these</p>
      <ul>
        {suggestions.map(suggestion => (
          <li key={suggestion}>
            <button type="button" onClick={() => onSelect(suggestion)} data-dd-action-name="chat_starter_suggestion">
              {suggestion}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default StarterSuggestions
